import {
    IServicesCategoryNomenclature, 
    IServicesCategoryNomenclatureListItem, 
    ServicesCategoryNomenclatureResponseType
} from "@/entity/servicesCategoryNomenclature/services.category.nomenclature.types";

export default class ServicesCategoryNomenclature implements IServicesCategoryNomenclature {
    total: number;
    data: IServicesCategoryNomenclatureListItem[] = [];
    constructor(data: ServicesCategoryNomenclatureResponseType) {
        this.total = data.total;
        
        if(data.data && data.data.length) {
            for (let i = 0; i < data.data.length; i++) {
                this.data.push(data.data[i]);
            }
        }
    }
}